import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
  tr_padding: {
    padding: '1px !important',
    width: '1%',
  },

  expand_tr_padding: {
    padding: '0 !important',
    width: 'auto',
  },

  worklist_tr_padding: {
    padding: '0 !important',
  },

  tr_icon_padding: {
    padding: '0',
  },

  tr_icons: {
    padding: '1px !important',
  },

  table_cell_container: {
    fontSize: theme.fonts.responsiveText,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    padding: '4px 0 !important',
  },

  worklist_table_cell_container: {
    fontSize: theme.fonts.responsiveText,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    padding: '4px 0 !important',
  },

  table_name_cell_container: {
    fontSize: theme.fonts.responsiveText,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    padding: '4px 0 !important',
  },

  table_font: {
    fontSize: theme.fonts.responsiveText,
    width: '100%',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    maxWidth: '100%',
  },

  table_date_font: {
    fontSize: theme.fonts.responsiveTextSmall,
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    maxWidth: '100%',
    overflow: 'hidden',
    padding: '0',
  },

  row_selected: {
    fontWeight: 'bold',
    fontSize: theme.fonts.responsiveText,
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    maxWidth: '100%',
    overflow: 'hidden',
  },

  tr_hover: {
    '&:hover': {
      boxShadow: '0px -1px 2px 1px rgb(115 115 115), 0px 2px 2px 0px rgb(115 115 115)',
    },
  },

  main_nested_tr_container: {
    '&:hover': {
      boxShadow: '0px -1px 2px 1px rgb(115 115 115), 0px 2px 2px 0px rgb(115 115 115)',
    },
  },

  tr_nested: {
    fontSize: theme.fonts.responsiveText,
    padding: '4px 2px !important',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },

  tr_nested_hover: {
    cursor: 'pointer',
    borderBottom: '1px solid  rgb(71, 71, 71)',
    '&:hover': {
      boxShadow: '  0px 0px 3px 1px rgb(48 48 48 / 63%), 0px 1px 2px 0px rgb(58 58 58 / 69%)',
    },
  },

  tr_nested_hover_selected: {
    cursor: 'default',
    borderBottom: '1px solid  rgb(71, 71, 71)',
    '&:hover': {
      boxShadow: '  0px 0px 3px 1px rgb(48 48 48 / 63%), 0px 1px 2px 0px rgb(58 58 58 / 69%)',
    },
  },

  tr_padding_nested: {
    padding: '1px !important',
    width: '25px',
    borderBottom: '1px solid  rgb(71, 71, 71)',
  },

  info_icons_cell: {
    display: 'flex',
    flexDirection: 'column',
  },

  risk_icon_complete: {
    color: theme.palette.accents.main,
  },

  table_placeholder: {
    color: 'gray',
    padding: '15%',
    border: 'none',
    fontSize: theme.fonts.responsiveMediumBig,
    padding: '14px 10px 10px',
    borderBottom: 'unset',
  },

  table_drag_placeholder: {
    padding: '40px 10px 10px',
    fontSize: theme.fonts.responsiveMedium,
    fontStyle: 'italic',
    color: 'gray',
    border: 'none',
  },

  drag_placeholder_icon: {
    color: 'gray',
    marginLeft: '6px',
  },

  dropzone_text: {
    color: theme.palette.accents.main,
    fontSize: theme.fonts.responsiveMediumBig,
  },

  previewChip_root: {
    maxWidth: theme.drawerWidthAvatar,
  },

  dropzone_root: {
    backgroundColor: 'inherit',
    minHeight: '70vh !important',
    padding: '1%',
    marginBottom: '10px',
    marginLeft: '1%',
    width: '99% !important',
  },

  dropzone_textContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },

  dropzone_icon: {
    width: '25px !important',
    color: `${theme.palette.accents.main} !important`,
    height: 'auto !important',
    marginLeft: '16px !important',
  },

  table_actions_menu: {
    display: 'flex',
    alignItems: 'center',
  },

  menu_icon: {
    marginRight: '6px',
    height: '18px',
  },

  tooltip_texts: {
    letterSpacing: '0.1rem',
    fontSize: theme.fonts.responsiveMedium,
    display: 'flex',
    alignItems: 'center',
    maxWidth: '100%',
    whiteSpace: 'normal',
    wordBreak: 'break-word',
    overflowWrap: 'anywhere',
  },

  tooltip_texts_margin: {
    letterSpacing: '0.1rem',
    fontSize: '12px',
    marginBottom: '4px',
  },

  drag_error: {
    fontSize: '12px',
    margin: '0px 20px',
    color: '#ffbbbb',
    letterSpacing: '0.1rem',
    fontStyle: 'italic',
    fontWeight: 'bold',
  },

  drag_error_texts: {
    fontSize: '10px',
    margin: '2px 20px',
    color: '#cfcfcf',
    letterSpacing: '0.1rem',
    fontStyle: 'italic',
    whiteSpace: 'break-spaces',
  },

  error_container: {
    marginBottom: '20px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    alignItems: 'stretch',
  },

  menu_text: {
    fontSize: theme.fonts.responsiveMedium,
  },

  hidden: {
    display: 'none',
  },

  hoverEffect: {
    '&:hover': {
      background: `${theme.palette.accents.light} !important`,
      boxShadow: '0px 0px 5px 0px #d7c2c2',
    },
  },

  bulkCheckbox: {
    padding: '2px',
    '& .MuiSvgIcon-root': {
      fontSize: '0.95rem',
    },
  },
}));
